import WebUnsupportedError from './WebUnsupportedError';
export default {
    openMenu() {
        throw new WebUnsupportedError();
    },
    closeMenu() {
        throw new WebUnsupportedError();
    },
    hideMenu() {
        throw new WebUnsupportedError();
    },
    addDevMenuCallbacks() {
        throw new WebUnsupportedError();
    },
};
//# sourceMappingURL=ExpoDevMenu.web.js.map